import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import SingleCol from "components/faqs/SingleCol";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;

const Heading = tw.h1`font-bold text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-gray-900 leading-tight`;
const HeadingRow = tw.div`flex flex-col items-center text-center`;
const Text = tw.div`mt-8 text-base text-gray-600 max-w-3xl mx-auto`;

const faqs = [
  {
    question: "Qu'est-ce que Tanga ?",
    answer: "Tanga est une plateforme digitale de gestion des visiteurs qui améliore la sécurité, la traçabilité et l'expérience d'accueil dans les entreprises et organisations."
  },
  {
    question: "Comment fonctionne le check-in avec Tanga ?",
    answer: "Les visiteurs peuvent être pré-enregistrés et reçoivent un QR code ou utilisent leur numéro de téléphone pour un check-in rapide et sécurisé à l'entrée."
  },
  {
    question: "Quels sont les avantages pour les entreprises ?",
    answer: "Tanga permet de gagner du temps, d'améliorer la sécurité, de générer des rapports détaillés sur les flux visiteurs, de simplifier la gestion des accès et d'assurer la conformité RGPD."
  },
  {
    question: "Quels sont les avantages pour les visiteurs ?",
    answer: "Les visiteurs bénéficient d'un enregistrement unique, d'un check-in rapide, d'une expérience d'accueil moderne et sans stress, et d'une meilleure confidentialité de leurs données."
  },
  {
    question: "Tanga est-il conforme à la réglementation sur la protection des données (RGPD/ARTCI) ?",
    answer: "Oui, Tanga applique des mesures strictes de sécurité et de conformité RGPD et ARTCI pour protéger toutes les données personnelles des visiteurs et des entreprises."
  },
  {
    question: "Où Tanga est-il disponible ?",
    answer: "Tanga est disponible en Côte d'Ivoire et dans plusieurs autres pays d'Afrique. Contactez-nous pour savoir si votre ville ou votre entreprise peut bénéficier de Tanga."
  },
  {
    question: "Comment planifier ou gérer un rendez-vous visiteur ?",
    answer: "Les équipes de sécurité et d'accueil peuvent planifier, pré-enregistrer et gérer les rendez-vous directement sur la plateforme Tanga."
  },
  {
    question: "Comment contacter le support Tanga ?",
    answer: "Vous pouvez contacter notre équipe support à support@tangagroup.africa pour toute question ou assistance." 
  }
];

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <SingleCol faqs={faqs} />
          {/* <HeadingRow>
            <Heading>Questions Fréquentes</Heading>
          </HeadingRow>
          <Text>
            <div className="space-y-8">
              {faqs.map((faq, index) => (
                <div key={index}>
                  <h2 className="text-xl font-semibold mb-2">{faq.question}</h2>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          </Text> */}
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
}; 